<div class="m-3">
  <app-tabset (tabChange)="setTab($event)">
    <app-tab
      id="properties"
      name="PROPERTIES"
      [active]="activeTab === 'properties'"
      *ngxPermissionsOnly="['DASHBOARD_PROPERTY_TAB']"
    >
      <div class="p-3">
        <div class="is-ancestor">
          <div
            class="tile is-parent is-justify-content-center is-flex-column is-align-items-center"
          >
            <h6 translationEditableDirective="TOTAL_PROPERTIES">
              {{ 'TOTAL_PROPERTIES' | translate }}
            </h6>
            <p>{{ propertyTotal.totalItems | number }}</p>
          </div>
          <div
            class="tile is-parent is-justify-content-center is-flex-column is-align-items-center"
          >
            <h6 translationEditableDirective="TOTAL_EXPECTED_REVENUE">
              {{ 'TOTAL_EXPECTED_REVENUE' | translate }}
            </h6>
            <p>{{ propertyTotal.totalExpectedRevenue | number }}</p>
          </div>
          <div
            class="tile is-parent is-justify-content-center is-flex-column is-align-items-center"
          >
            <h6 translationEditableDirective="TOTAL_COLLECTED_REVENUE">
              {{ 'TOTAL_COLLECTED_REVENUE' | translate }}
            </h6>
            <p>{{ propertyTotal.totalCollectedRevenue | number }}</p>
          </div>
          <div
            class="tile is-parent is-justify-content-center is-flex-column is-align-items-center"
          >
            <h6 translationEditableDirective="PERCENTAGE">
              {{ 'PERCENTAGE' | translate }}
            </h6>
            <p>{{ propertyTotal.percentage | number }}</p>
          </div>
        </div>

        <div class="is-ancestor">
          <div class="tile is-parent">
            <canvas
              *ngIf="propertyCountByPropertyTypeChart"
              baseChart
              [data]="propertyCountByPropertyTypeChart.values"
              [labels]="propertyCountByPropertyTypeChart.labels"
              type="pie"
              [options]="propertyCountByPropertyTypeChart.options"
            >
            </canvas>
          </div>
          <div class="tile is-parent">
            <canvas
              *ngIf="propertyExpectedVsActualRevenueChart"
              baseChart
              [datasets]="propertyExpectedVsActualRevenueChart.datasets"
              [labels]="propertyExpectedVsActualRevenueChart.labels"
              type="bar"
              [options]="propertyExpectedVsActualRevenueChart.options"
              [legend]="true"
            >
            </canvas>
          </div>
        </div>

        <div class="is-ancestor">
          <div class="tile is-parent">
            <canvas
              *ngIf="propertyExpectedTotalRevenueChart"
              baseChart
              [data]="propertyExpectedTotalRevenueChart.values"
              [labels]="propertyExpectedTotalRevenueChart.labels"
              type="pie"
              [options]="propertyExpectedTotalRevenueChart.options"
            >
            </canvas>
          </div>
          <div class="tile is-parent">
            <canvas
              *ngIf="propertyExpectedAverageRevenueChart"
              baseChart
              [data]="propertyExpectedAverageRevenueChart.values"
              [labels]="propertyExpectedAverageRevenueChart.labels"
              type="pie"
              [options]="propertyExpectedAverageRevenueChart.options"
            >
            </canvas>
          </div>
        </div>
      </div>
    </app-tab>
    <app-tab
      id="licensing"
      name="BUSINESSES"
      [active]="activeTab === 'licensing'"
      *ngxPermissionsOnly="['DASHBOARD_LICENSE_TAB']"
    >
      <div class="p-3">
        <div class="is-ancestor">
          <div
            class="tile is-parent is-justify-content-center is-flex-column is-align-items-center"
          >
            <h6 translationEditableDirective="TOTAL_BUSINESSES">
              {{ 'TOTAL_BUSINESSES' | translate }}
            </h6>
            <p>{{ businessTotal.totalItems | number }}</p>
          </div>
          <div
            class="tile is-parent is-justify-content-center is-flex-column is-align-items-center"
          >
            <h6 translationEditableDirective="TOTAL_EXPECTED_REVENUE">
              {{ 'TOTAL_EXPECTED_REVENUE' | translate }}
            </h6>
            <p>{{ businessTotal.totalExpectedRevenue | number }}</p>
          </div>
          <div
            class="tile is-parent is-justify-content-center is-flex-column is-align-items-center"
          >
            <h6 translationEditableDirective="TOTAL_COLLECTED_REVENUE">
              {{ 'TOTAL_COLLECTED_REVENUE' | translate }}
            </h6>
            <p>{{ businessTotal.totalCollectedRevenue | number }}</p>
          </div>
          <div
            class="tile is-parent is-justify-content-center is-flex-column is-align-items-center"
          >
            <h6 translationEditableDirective="PERCENTAGE">
              {{ 'PERCENTAGE' | translate }}
            </h6>
            <p>{{ businessTotal.percentage | number }}</p>
          </div>
        </div>

        <div class="is-ancestor">
          <div class="tile is-parent">
            <canvas
              *ngIf="businessCountByPropertyTypeChart"
              baseChart
              [data]="businessCountByPropertyTypeChart.values"
              type="pie"
              [options]="businessCountByPropertyTypeChart.options"
            >
            </canvas>
          </div>
          <div class="tile is-parent">
            <canvas
              *ngIf="businessExpectedVsActualRevenueChart"
              baseChart
              [datasets]="businessExpectedVsActualRevenueChart.datasets"
              [labels]="businessExpectedVsActualRevenueChart.labels"
              type="bar"
              [options]="businessExpectedVsActualRevenueChart.options"
              [legend]="true"
            >
            </canvas>
          </div>
        </div>

        <div class="is-ancestor">
          <div class="tile is-parent">
            <canvas
              *ngIf="businessExpectedTotalRevenueChart"
              baseChart
              [data]="businessExpectedTotalRevenueChart.values"
              type="pie"
              [options]="businessExpectedTotalRevenueChart.options"
            >
            </canvas>
          </div>
          <div class="tile is-parent">
            <canvas
              *ngIf="businessExpectedAverageRevenueChart"
              baseChart
              [data]="businessExpectedAverageRevenueChart.values"
              type="pie"
              [options]="businessExpectedAverageRevenueChart.options"
            >
            </canvas>
          </div>
        </div>
      </div>
    </app-tab>
  </app-tabset>
</div>
